import type { Connector } from "@shared/types/connection"
import { onSnapshot } from "firebase/firestore"
import { useEffect, useState } from "react"

import { connectorsRef } from "../firestore/db"

export function useConnectors(): Record<string, Connector> {
  const [connectors, setConnectors] = useState<Record<string, Connector>>({})

  useEffect(() => {
    const unsubscribe = onSnapshot(connectorsRef(), (snapshot) => {
      const map: Record<string, Connector> = {}
      for (const doc of snapshot.docs) {
        const c = doc.data()
        map[c.oid] = c
      }
      setConnectors(map)
    })
    return unsubscribe
  }, [])

  return connectors
}
